import { render, staticRenderFns } from "./companies-card.vue?vue&type=template&id=2cc9dee9&scoped=true&"
import script from "./companies-card.vue?vue&type=script&lang=js&"
export * from "./companies-card.vue?vue&type=script&lang=js&"
import style0 from "./companies-card.vue?vue&type=style&index=0&id=2cc9dee9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc9dee9",
  null
  
)

export default component.exports